export const tableFilterOption = {
  cursor: 'pointer',
  '&:hover': {
    textDecoration: 'underline',
    color: 'secondary.main',
  },
};
